import { render } from "./PaymentLiquidations.vue?vue&type=template&id=47c7290e"
import script from "./PaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./PaymentLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__